/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../Fixes';
import Builder from '../../Builder';
import '../common/time';
import '../common/currency';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "salesreporter": {
        "nested": {
          "service": {
            "nested": {
              "SalesForecastReportRequest": {
                "fields": {
                  "merchantToken": {
                    "type": "string",
                    "id": 1,
                    "rule": "required"
                  },
                  "locationIds": {
                    "type": "string",
                    "id": 2,
                    "rule": "repeated"
                  }
                }
              },
              "SalesForecastReportResponse": {
                "fields": {
                  "reportData": {
                    "type": ".squareup.salesreporter.service.SalesForecastReportData",
                    "id": 1,
                    "rule": "repeated"
                  }
                }
              },
              "SalesForecastReportData": {
                "fields": {
                  "locationId": {
                    "type": "string",
                    "id": 1,
                    "rule": "required"
                  },
                  "reportDataPeriodName": {
                    "type": "string",
                    "id": 2,
                    "rule": "required"
                  },
                  "reportDataPeriod": {
                    "type": ".squareup.common.time.DateTimeInterval",
                    "id": 3,
                    "rule": "optional"
                  },
                  "estimatedGpv": {
                    "type": ".squareup.common.Money",
                    "id": 4,
                    "rule": "optional"
                  },
                  "estimatedGpvGrowth": {
                    "type": "string",
                    "id": 5,
                    "rule": "optional"
                  },
                  "gpvTrailingPp": {
                    "type": ".squareup.common.Money",
                    "id": 6,
                    "rule": "optional"
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.salesreporter?.nested?.service?.nested?.SalesForecastReportRequest && !$root.nested?.squareup?.nested?.salesreporter?.nested?.service?.nested?.SalesForecastReportResponse && !$root.nested?.squareup?.nested?.salesreporter?.nested?.service?.nested?.SalesForecastReportData) {
  $root.addJSON(jsonData);
}

/**
 * SOURCE SalesForecastReportRequest @ squareup/salesreporter/forecast_report.proto at 13:1
 */
export const SalesForecastReportRequest = $root.lookupType('squareup.salesreporter.service.SalesForecastReportRequest');
fixType(SalesForecastReportRequest, {
  merchantToken: {
    notEmpty: true
  },
  locationIds: {
    required: true
  }
});
Builder.createAndAttachToType(SalesForecastReportRequest);
/**
 * SOURCE SalesForecastReportResponse @ squareup/salesreporter/forecast_report.proto at 23:1
 */
export const SalesForecastReportResponse = $root.lookupType('squareup.salesreporter.service.SalesForecastReportResponse');
fixType(SalesForecastReportResponse);
Builder.createAndAttachToType(SalesForecastReportResponse);
/**
 * SOURCE SalesForecastReportData @ squareup/salesreporter/forecast_report.proto at 27:1
 */
export const SalesForecastReportData = $root.lookupType('squareup.salesreporter.service.SalesForecastReportData');
fixType(SalesForecastReportData);
Builder.createAndAttachToType(SalesForecastReportData);